/**
 * Created by rjulius on 2/15/16.
 */
import Model from "common/framework/Model";
import NestedData from "common/framework/NestedData";
import FormStepModel from "common/models/form/FormStepModel";
export default Model.define({
    init: function(options) {
        var config = $.extend({}, options);
        if (config.steps == undefined || !config.steps.length) {
            config.steps = [];
        }
        Model.fn.init.apply(this, arguments);

        this._initStyles(options);

        this.initLocalData();
        this.setLocalData();
    },
    id: "id",
    fields: {
        // id of the form design
        id: {
            type: "string"
        },
        name: {
            type: "string"
        },
        width: {
            type: "number"
        },
        height: {
            type: "number"
        },
        currentStepId: {
            type: "string"
        },
        steps: {},
        // Store docId, client-side only, if the instance was retrieved from a document
        docId: {
            transient: true,
            type: "string"
        },
        borderColor: {
            type: "string"
        },
        borderSize: {
            type: "string"
        },
        backgroundColor: {
            type: "string",
            defaultValue: "#FFFFFF"
        },
        fontSize: {
            type: "string"
        },
        fontFamily: {
            type: "string"
        },
        fontColor: {
            type: "string"
        },
        fontBold: {
            type: "boolean",
            defaultValue: false
        },
        fontWeight: {
            transient: true
        },
        fontItalic: {
            type: "boolean",
            defaultValue: false
        },
        fontStyle: {
            transient: true
        }
    },

    toJSON: function() {
        var base = Model.fn.toJSON.apply(this, arguments);

        base.steps = this.stepsDS.localData();
        delete base.stepsDS;

        return base;
    },
    setLocalData: function() {
        this.stepsDS.localData(this.steps || []);
        this.stepsDS.read();
    },

    accept: function(obj) {
        var res = Model.fn.accept.apply(this, arguments);
        this._initStyles(obj);
        this.setLocalData();
        return res;
    },

    initLocalData: function() {
        kendo.data.ObservableObject.fn.set.call(this, "stepsDS", new NestedData({
            schema: {
                model: FormStepModel
            }
        }));

    },

    _initStyles: function(form) {
        // Parse styles into more usable fields on the Model
        if (form) {
            if (form.fontBold) {
                this.set("fontWeight", "bold");
            } else {
                this.set("fontWeight", "normal");
            }
            if (form.fontItalic) {
                this.set("fontStyle", "italic");
            } else {
                this.set("fontStyle", "normal");
            }
            if (form.borderSize && form.borderSize > 0) {
                this.set("borderSize", form.borderSize + "px");
            }
            if (form.backgroundColor && form.backgroundColor.indexOf("#") != 0) {
                this.set("backgroundColor", "#" + form.backgroundColor);
            }
            if (form.fontFamily && form.fontFamily.indexOf(",") > -1) {
                var family = form.fontFamily;
                if (family.indexOf("Verdana") > -1) {
                    this.set("fontFamily", "verdana");
                } else if (family.indexOf("Times") > -1) {
                    this.set("fontFamily", "times");
                } else {
                    this.set("fontFamily", "arial");
                }
            }
            if (form.fontColor && form.fontColor.indexOf("#") != 0) {
                this.set("fontColor", "#" + form.fontColor);
            }
            if (form.fontSize) {
                this.set("fontSize", "" + form.fontSize);
            }
        }
    }
})